import { render, staticRenderFns } from "./Create-Contact.vue?vue&type=template&id=d9c8f5d0&scoped=true"
import script from "./Create-Contact.vue?vue&type=script&lang=js"
export * from "./Create-Contact.vue?vue&type=script&lang=js"
import style0 from "./Create-Contact.vue?vue&type=style&index=0&id=d9c8f5d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9c8f5d0",
  null
  
)

export default component.exports